// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MceEventClassRow, MceEventClassRowT, verifyMceEventClassRow } from "./mce-event-class-row";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";
import { EventFamily } from "../mce/event-family";

/**
 * The response to every read and every write.
 */
export class MceEventClassList implements flatbuffers.IUnpackableObject<MceEventClassListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MceEventClassList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMceEventClassList(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassList,
  ): MceEventClassList {
    return (obj || new MceEventClassList()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMceEventClassList(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassList,
  ): MceEventClassList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MceEventClassList()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The `If-Match` value for the next write: `mce-cdo:` and the sha256 of
   * the stored `cdo_binary`.
   */
  cdoEtag(): string;
  cdoEtag(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  cdoEtag(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  eventsFamily(): EventFamily {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : EventFamily.Unspecified;
  }

  rows(index: number, obj?: MceEventClassRow): MceEventClassRow | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new MceEventClassRow()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  rowsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Advisory: a VTS running this product in a legacy-emitting mode will
   * refuse this adapter. VTS makes the exact check.
   */
  needsTableMode(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startMceEventClassList(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, adapterIdOffset, 0);
  }

  static addCdoEtag(builder: flatbuffers.Builder, cdoEtagOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, cdoEtagOffset, 0);
  }

  static addEventsFamily(builder: flatbuffers.Builder, eventsFamily: EventFamily) {
    builder.addFieldInt8(2, eventsFamily, EventFamily.Unspecified);
  }

  static addRows(builder: flatbuffers.Builder, rowsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, rowsOffset, 0);
  }

  static createRowsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRowsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNeedsTableMode(builder: flatbuffers.Builder, needsTableMode: boolean) {
    builder.addFieldInt8(4, +needsTableMode, +false);
  }

  static endMceEventClassList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // adapter_id
    builder.requiredField(offset, 6); // cdo_etag
    return offset;
  }

  static createMceEventClassList(
    builder: flatbuffers.Builder,
    adapterIdOffset: flatbuffers.Offset,
    cdoEtagOffset: flatbuffers.Offset,
    eventsFamily: EventFamily,
    rowsOffset: flatbuffers.Offset,
    needsTableMode: boolean,
  ): flatbuffers.Offset {
    MceEventClassList.startMceEventClassList(builder);
    MceEventClassList.addAdapterId(builder, adapterIdOffset);
    MceEventClassList.addCdoEtag(builder, cdoEtagOffset);
    MceEventClassList.addEventsFamily(builder, eventsFamily);
    MceEventClassList.addRows(builder, rowsOffset);
    MceEventClassList.addNeedsTableMode(builder, needsTableMode);
    return MceEventClassList.endMceEventClassList(builder);
  }

  unpack(): MceEventClassListT {
    return new MceEventClassListT(
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.cdoEtag(),
      this.eventsFamily(),
      this.bb!.createObjList<MceEventClassRow, MceEventClassRowT>(
        this.rows.bind(this),
        this.rowsLength(),
      ),
      this.needsTableMode(),
    );
  }

  unpackTo(_o: MceEventClassListT): void {
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.cdoEtag = this.cdoEtag();
    _o.eventsFamily = this.eventsFamily();
    _o.rows = this.bb!.createObjList<MceEventClassRow, MceEventClassRowT>(
      this.rows.bind(this),
      this.rowsLength(),
    );
    _o.needsTableMode = this.needsTableMode();
  }

  unpackFields(...fields: string[]): MceEventClassListT {
    const t = new MceEventClassListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("cdo_etag")) {
      t.cdoEtag = this.cdoEtag();
    }
    if (fieldSet.has("events_family")) {
      t.eventsFamily = this.eventsFamily();
    }
    if (fieldSet.has("rows")) {
      t.rows = this.bb!.createObjList<MceEventClassRow, MceEventClassRowT>(
        this.rows.bind(this),
        this.rowsLength(),
      );
    }
    if (fieldSet.has("needs_table_mode")) {
      t.needsTableMode = this.needsTableMode();
    }
    return t;
  }
}

export class MceEventClassListT implements flatbuffers.IGeneratedObject {
  constructor(
    public adapterId: UuidT | null = null,
    public cdoEtag: string | Uint8Array | null = null,
    public eventsFamily: EventFamily = EventFamily.Unspecified,
    public rows: MceEventClassRowT[] = [],
    public needsTableMode: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.adapterId === null || this.adapterId === undefined) {
      throw new Error('Required field "adapter_id" is not set');
    }
    if (this.cdoEtag === null || this.cdoEtag === undefined) {
      throw new Error('Required field "cdo_etag" is not set');
    }
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const cdoEtag = this.cdoEtag !== null ? builder.createString(this.cdoEtag!) : 0;
    const rows = MceEventClassList.createRowsVector(
      builder,
      builder.createObjectOffsetList(this.rows),
    );

    return MceEventClassList.createMceEventClassList(
      builder,
      adapterId,
      cdoEtag,
      this.eventsFamily,
      rows,
      this.needsTableMode,
    );
  }

  clone(): MceEventClassListT {
    const obj = new MceEventClassListT();
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.cdoEtag = this.cdoEtag;
    obj.eventsFamily = this.eventsFamily;
    obj.rows = this.rows.map((e) => e.clone());
    obj.needsTableMode = this.needsTableMode;
    return obj;
  }

  equals(other: MceEventClassListT): boolean {
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.cdoEtag !== other.cdoEtag) return false;
    if (this.eventsFamily !== other.eventsFamily) return false;
    if (this.rows.length !== other.rows.length) return false;
    for (let i = 0; i < this.rows.length; i++) {
      const a = this.rows[i];
      const b = other.rows[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.needsTableMode !== other.needsTableMode) return false;
    return true;
  }
}

export function verifyMceEventClassList(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "adapter_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "cdo_etag");
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMceEventClassRow);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
  } finally {
    verifier.popDepth();
  }
}
